/* bmcD-product.js: default product template helpers (16 books + 2 courses), group D of the whole-store Josh pass
   (2026-09-28). Loaded only by sections/main-product.liquid for non-frozen products, never on landing pages.
   1 pinch zoom back on, 2 Add to cart states (+ the bar's button taps the main one), 3 quantity line total,
   4 sticky buy bar, 5 desktop gallery arrows,
   6 reader quotes stand out, 7 jump links open their accordion. */
(function () {
  if (window.bmcDInit) return;
  window.bmcDInit = true;
  var root = document.querySelector('product-info.bmcD');
  if (!root) return;
  var sid = root.getAttribute('data-section');

  /* 1. An app rewrites the viewport to user-scalable=0, which blocks pinch zoom. Put the theme's value back. */
  var VP = 'width=device-width,initial-scale=1';
  function bmcDFixViewport() {
    var m = document.querySelector('meta[name="viewport"]');
    if (m && m.getAttribute('content') !== VP) m.setAttribute('content', VP);
  }
  bmcDFixViewport();
  try {
    new MutationObserver(bmcDFixViewport).observe(document.head, { subtree: true, childList: true, attributes: true, attributeFilter: ['content'] });
  } catch (e) {}

  /* 2. Add to cart states: "Added to your cart", then after 2 s a real "Go to your cart" link in the button's place.
     The cart app (Monster) may run the add itself, so success is read from the /cart/add request that follows a tap
     on our button, or from Dawn's cartUpdate event, whichever comes first. */
  var form = document.getElementById('product-form-' + sid);
  var btn = document.getElementById('ProductSubmitButton-' + sid);
  var bar = document.getElementById('bmcD-bar');
  var barBtn = bar ? bar.querySelector('.bmcD-bar__atc') : null;
  var tpl = document.getElementById('bmcD-atc-states');
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var state = 'add', timer = 0, pending = 0;
  var btns = [btn, barBtn].filter(Boolean);
  var orig = btns.map(function (b) { var l = b.querySelector(':scope > span'); return l ? l.innerHTML : ''; });
  var links = [];
  function tplHtml(s) { var src = tpl ? tpl.content.querySelector('[data-s="' + s + '"]') : null; return src ? src.innerHTML : ''; }
  /* Dawn's .button is display:flex, so the hidden attribute alone does not hide it: the inline display:none (and the
     [hidden] rule in bmcD-product.css) make sure exactly one call to action shows in the buy box and in the bar. The
     link does not carry product-form__submit, so no add to cart script can treat a tap on it as a new add. */
  function setState(s) {
    state = s;
    btns.forEach(function (b, i) {
      var a = links[i], l = b.querySelector(':scope > span');
      var hadFocus = b === document.activeElement || (a && a === document.activeElement);
      if (a) { a.remove(); links[i] = null; }
      b.hidden = false;
      b.style.removeProperty('display');
      b.classList.toggle('bmcD-done', s !== 'add');
      /* the bar uses short labels ("Added", "Go to cart") so it never grows a second row on a phone */
      var sfx = b === barBtn ? '-bar' : '';
      if (l) l.innerHTML = s === 'added' ? tplHtml('added' + sfx) : orig[i];
      if (s === 'go') {
        a = document.createElement('a');
        a.href = cartUrl;
        a.className = b.className.replace(/\b(loading|product-form__submit)\b/g, ' ').replace(/\s+/g, ' ').trim() + ' bmcD-go';
        a.innerHTML = '<span>' + tplHtml('go' + sfx) + '</span>';
        b.hidden = true;
        b.style.setProperty('display', 'none', 'important');
        b.insertAdjacentElement('afterend', a);
        links[i] = a;
        if (hadFocus) { try { a.focus({ preventScroll: true }); } catch (e) {} }
      } else if (hadFocus && a) {
        try { b.focus({ preventScroll: true }); } catch (e) {}
      }
    });
  }
  function added() {
    pending = 0;
    setState('added');
    clearTimeout(timer);
    timer = setTimeout(function () { setState('go'); }, 2000);
  }
  function variantId() { var i = form ? form.querySelector('[name="id"]') : null; return i ? String(i.value) : ''; }
  /* The bar's button is a plain button: it taps the main Add to cart, so the add runs once, down the main path. */
  if (barBtn && btn) {
    barBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled || btn.hidden || btn.getAttribute('aria-disabled') === 'true') return;
      pending = Date.now();
      btn.click();
    });
  }
  if (form && btn) {
    var arm = function (e) { if (e.target.closest && e.target.closest('#ProductSubmitButton-' + sid + ', .bmcD-bar__atc')) pending = Date.now(); };
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (t) { window.addEventListener(t, arm, { capture: true, passive: true }); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') arm(e); }, true);
    form.addEventListener('submit', function () { pending = Date.now(); }, true);
    /* PUB_SUB_EVENTS is a top-level const in constants.js: reachable by name, not as window.PUB_SUB_EVENTS. */
    var bmcDEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    if (typeof window.subscribe === 'function' && bmcDEvents) {
      window.subscribe(bmcDEvents.cartUpdate, function (ev) {
        if (ev && ev.source === 'product-form' && String(ev.productVariantId) === variantId()) added();
      });
      window.subscribe(bmcDEvents.cartError, function (ev) {
        if (ev && ev.source === 'product-form') { pending = 0; clearTimeout(timer); setState('add'); }
      });
    }
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (pending && /\/cart\/add/.test(en.name) && Date.now() - pending < 15000 && !(en.responseStatus >= 400)) added();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
    root.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('quantity__input') && state !== 'add') { clearTimeout(timer); setState('add'); } });
  }

  /* 3. Quantity line total (books): "Total for 3: $89.97". */
  var q = document.getElementById('Quantity-' + sid);
  var out = document.getElementById('bmcD-qty-total');
  if (q && out) {
    var cents = parseInt(out.getAttribute('data-price'), 10) || 0;
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: out.getAttribute('data-cur') || 'USD' }); } catch (e) { fmt = null; }
    var upd = function () {
      var n = Math.max(1, parseInt(q.value, 10) || 1);
      out.textContent = n > 1 && fmt ? 'Total for ' + n + ': ' + fmt.format((cents * n) / 100) : '';
    };
    q.addEventListener('change', upd); q.addEventListener('input', upd); upd();
  }

  /* 4. Sticky buy bar: on when the main button is off screen and the shopper is not scrolling down. */
  if (bar && btn) {
    document.body.appendChild(bar);
    var atcIn = true, passed = false, lastY = window.scrollY, dir = 'up', ticking = false;
    var hdr = document.querySelector('.section-header');
    var desk = window.matchMedia('(min-width: 990px)');
    var paint = function () {
      /* phones: also while the button is still below the first screen, so a buy button is always in view;
         desktop: only after the shopper has scrolled past it */
      var on = !atcIn && dir === 'up' && (passed || !desk.matches);
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !on;
      if (desk.matches) {
        var top = 0;
        if (hdr) { var r = hdr.getBoundingClientRect(); top = Math.max(0, Math.round(r.bottom)); }
        bar.style.setProperty('--bmcD-top', top + 'px');
      }
    };
    /* watch the buttons block, not the button: the button is hidden in the "Go to your cart" state, and a hidden
       element would read as off screen and call the bar up next to the link */
    var watch = btn.closest('.product-form__buttons') || btn;
    new IntersectionObserver(function (es) { atcIn = es[0].isIntersecting; passed = !atcIn && es[0].boundingClientRect.top < 0; paint(); }, { threshold: 0 }).observe(watch);
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        if (Math.abs(y - lastY) > 8) { dir = y > lastY ? 'down' : 'up'; lastY = y; }
        ticking = false;
        paint();
      });
    }, { passive: true });
    if (hdr) hdr.addEventListener('transitionend', paint);
    window.addEventListener('resize', paint);
    paint();
  }

  /* 5. Desktop gallery arrows: step through the thumbnails (Dawn's media-gallery switches the image). */
  var gnav = root.querySelector('.bmcD-gnav');
  if (gnav) {
    var thumbs = function () { return Array.prototype.slice.call(root.querySelectorAll('[id^="GalleryThumbnails-"] .thumbnail-list__item')); };
    var step = function (d) {
      var t = thumbs(); if (t.length < 2) return;
      var i = t.findIndex(function (li) { var b = li.querySelector('button'); return b && b.getAttribute('aria-current') === 'true'; });
      if (i < 0) i = 0;
      var n = t[(i + d + t.length) % t.length].querySelector('button');
      if (n) n.click();
    };
    gnav.querySelector('.bmcD-gnav__prev').addEventListener('click', function () { step(-1); });
    gnav.querySelector('.bmcD-gnav__next').addEventListener('click', function () { step(1); });
    var place = function () {
      var m = root.querySelector('.product__media-list .product__media-item.is-active .product-media-container') || root.querySelector('.product__media-list .product-media-container');
      var g = root.querySelector('media-gallery');
      if (!m || !g) return;
      var mr = m.getBoundingClientRect(), gr = g.getBoundingClientRect();
      if (mr.height > 0) g.style.setProperty('--bmcD-gnav-top', Math.round(mr.top - gr.top + mr.height / 2) + 'px');
    };
    window.addEventListener('load', place); window.addEventListener('resize', place); setTimeout(place, 600);
  }

  /* 6. Reader quotes stand out: tag the list that follows a "What readers say" heading in older descriptions. */
  root.querySelectorAll('.bmcD-desc h3, .bmcD-desc h4').forEach(function (h) {
    var nx = h.nextElementSibling;
    if (/what (readers|musicians|students) (say|are saying)/i.test(h.textContent) && nx && nx.tagName === 'UL') nx.classList.add('bmcD-quotes');
  });

  /* 7. Jump links scroll without adding a history entry (Back still returns to the page the shopper came from)
     and open their accordion when it is closed. */
  document.addEventListener('click', function (e) {
    /* f9i (P7): the Amazon reviews link (#bmcW2D-reviews) scrolls the same way; bmcW2D.js keeps #bmcW2D-v (the sample) */
    var a = e.target.closest ? e.target.closest('a[href^="#bmcD-"], a[href^="#bmcW2D-"]:not([href="#bmcW2D-v"])') : null;
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var d = t.tagName === 'DETAILS' ? t : t.closest('details');
    if (d) d.open = true;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
    if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    try { t.focus({ preventScroll: true }); } catch (err) {}
  });
})();

/* 8. Offers (f48, Dan 2026-09-28). Print books ship only to the US, UK and Canada, so the book offer box shows only
   when the visitor's country is one of those: the same sessionStorage key and lookup the landing pages use. Unknown
   country: it stays hidden. When "Next in the series" shows, the same book's plain row in "Pairs well with" steps
   aside, so the book is offered once. */
(function () {
  if (window.bmcDOffersInit) return;
  window.bmcDOffersInit = true;
  var boxes = document.querySelectorAll('[data-bmcd-geo]');
  if (!boxes.length) return;
  var OK = ['US', 'GB', 'CA'];
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  function show(code) {
    code = String(code || '').toUpperCase();
    if (OK.indexOf(code) < 0) return;
    each(boxes, function (b) {
      b.hidden = false;
      each(b.querySelectorAll('[data-bmcd-next]'), function (n) {
        var id = n.getAttribute('data-bmcd-next');
        each(document.querySelectorAll('.bmcD-pair'), function (li) {
          var i = li.querySelector('input[name="id"]');
          if (i && i.value === id) li.hidden = true;
        });
      });
    });
    each(document.querySelectorAll('.bmcD-pairs'), function (w) {
      if (!w.querySelector('.bmcD-pair:not([hidden])')) w.hidden = true;
    });
  }
  var c = null;
  try { c = sessionStorage.getItem('bmc_geo_country'); } catch (e) {}
  if (c) { show(c); return; }
  fetch('/browsing_context_suggestions.json?source=geolocation_recommendation', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      var code = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (code) { try { sessionStorage.setItem('bmc_geo_country', String(code).toUpperCase()); } catch (e) {} show(code); }
    })
    .catch(function () {});
})();

/* f9t (W4E, P43): estimated delivery dates on book pages, the cart page's own rule (bmcf-cart.js F.eta). f9za (W5SHIP,
   2026-10-05): printed in the US in 3 to 5 business days, then 5 to 7 business days by USPS Media Mail in the continental
   US (the shipping policy; Bookvault + USPS, swarm-w5/shipping/transit.json), so 8 to 12 business days from today. The
   line stays hidden until it has real dates. */
(function () {
  var els = document.querySelectorAll('[data-bmcw4e-eta]');
  if (!els.length) return;
  function addBiz(d, n) { d = new Date(d.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function day(d) { try { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString().slice(4, 10); } }
  var now = new Date(), t = day(addBiz(now, 8)) + ' to ' + day(addBiz(now, 12));
  for (var i = 0; i < els.length; i++) {
    var s = els[i].querySelector('[data-bmcw4e-eta-dates]');
    if (!s) continue;
    s.textContent = t;
    els[i].hidden = false;
  }
})();
